'use client'
import {
  useConfig_default
} from "./chunk-UDUUTZIS.mjs";

// src/hooks/useTranslation.ts
var useTranslation = (...args) => {
  return useConfig_default().i18n.useTranslation(...args);
};

export {
  useTranslation
};
//# sourceMappingURL=chunk-YB6SGOEW.mjs.map